import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useMemo } from "react";

export default function LineCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const code =  useMemo(() => searchParams.get("code"), [searchParams]);
  const state = useMemo(() => searchParams.get("state"), [searchParams]);
  const error = useMemo(() => searchParams.get("error"), [searchParams]);

  const isValidState = (state) => {
    return state === "a2v-line-1752204462471";
  };

  useEffect(() => {
    if (!error && code && isValidState(state)) {
      const hrefBeforeConnectLine = localStorage.getItem("href_before_connect_line");
      if (hrefBeforeConnectLine) {
        const redirectUrl = new URL(hrefBeforeConnectLine);
        redirectUrl.searchParams.set("line_code", code);
        redirectUrl.searchParams.set("line_state", state);
        redirectUrl.searchParams.set("open_confirm_password", "true");

        window.location.href = redirectUrl.toString();

        localStorage.removeItem("href_before_connect_line");
      } else {
        navigate("/"); // Redirect to home or another appropriate page
      }
    } else {
      const hrefBeforeConnectLine = localStorage.getItem("href_before_connect_line");
      if (hrefBeforeConnectLine) {
        const redirectUrl = new URL(hrefBeforeConnectLine);
        redirectUrl.searchParams.set("line_error", error ?? "unknown_error");
        window.location.href = redirectUrl.toString();

        localStorage.removeItem("href_before_connect_line");
      } else {
        navigate("/"); // Redirect to home or another appropriate page
      }
    }
  }, [code, state, error])

  return null; // This component does not render anything
}